import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  isOpen = false;
  private resetSubject = new Subject<void>();

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  resetAfterPayment(): void {
    this.isOpen = false;
    this.resetSubject.next();
  }

  onResetAfterPayment() {
    return this.resetSubject.asObservable();
  }
}
